import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
import ArticleRight from './detail/ArticleRight.vue';
import ArticleContent from './detail/ArticleContent.vue';
import { ref } from "vue";
import { useRoute } from "vue-router";
import { XiaoniuFrontedControllerService } from "../../../generated/services/XiaoniuFrontedControllerService";
import { onMounted } from "vue";
import { SysDictDataControllerService } from "../../../generated";
import { useLoginUserStore } from "@/store/loginUser";
export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleDetail',
  setup(__props) {
    const route = useRoute();
    const articleDetail = ref({});
    const getArticleDetail = async () => {
      const id = Number(route.params.id);
      if (!isNaN(id)) {
        const res = await XiaoniuFrontedControllerService.getArticleDetailUsingGet(id);
        articleDetail.value = res.data;
      } else {
        //如果id为空 默认获取22号文章 牛站介绍
        const res = await XiaoniuFrontedControllerService.getArticleDetailUsingGet(22);
        articleDetail.value = res.data;
      }
    };
    const dicType = ref("blog_type");
    const articleDictList = ref([]);
    const getDictArticleData = () => {
      //获取字典数据
      SysDictDataControllerService.dictTypeUsingGet(dicType.value).then(res => {
        if (res.code === 200) {
          articleDictList.value = res.data;
        }
      });
    };
    const useloginUser = useLoginUserStore();
    const blogTopFiveList = ref([]);
    //添加浏览量 目前采用的是ip地址的方案
    const putBlogView = async () => {
      const blogId = Number(route.params.id);
      if (!isNaN(blogId)) {
        XiaoniuFrontedControllerService.addBlogViewUsingPost(blogId);
      }
    };
    //获取浏览量
    const getBlogTopFive = async () => {
      const res = await XiaoniuFrontedControllerService.topFiveBlogUsingPost();
      if (res.code === 200) {
        blogTopFiveList.value = res.data;
      }
    };
    onMounted(() => {
      getArticleDetail();
      //获取文章字典
      getDictArticleData();
      //添加浏览量
      putBlogView();
      //获取浏览量
      getBlogTopFive();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 30
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 16,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(ArticleContent, {
            "article-detail": articleDetail.value,
            "dict-list": articleDictList.value
          }, null, 8, ["article-detail", "dict-list"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 8
        }, {
          default: _withCtx(() => [_createVNode(ArticleRight, {
            "browse-list": blogTopFiveList.value
          }, null, 8, ["browse-list"])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});